'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProps = exports.hide = exports.show = exports.SET_MODAL_PROPS = exports.HIDE_MODAL = exports.SHOW_MODAL = undefined;

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _initialState;

exports.default = reducer;

var _modals = require('constants/modals');

var MODALS = _interopRequireWildcard(_modals);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_MODAL = exports.SHOW_MODAL = 'tq-plus-admin/notifications/SHOW_MODAL';
var HIDE_MODAL = exports.HIDE_MODAL = 'tq-plus-admin/notifications/HIDE_MODAL';
var SET_MODAL_PROPS = exports.SET_MODAL_PROPS = 'tq-plus-admin/notifications/SET_MODAL_PROPS';

var initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, MODALS.DEFAULT, {
  isOpen: false,
  onCancel: function onCancel() {}
}), (0, _defineProperty3.default)(_initialState, MODALS.CONFIRM, {
  isOpen: false,
  onCancel: function onCancel() {}
}), (0, _defineProperty3.default)(_initialState, MODALS.LOGIN, {
  isOpen: false,
  onCancel: function onCancel() {}
}), (0, _defineProperty3.default)(_initialState, MODALS.RULES, {
  isOpen: false,
  onCancel: function onCancel() {}
}), _initialState);

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW_MODAL:
      {
        var _action$modal = action.modal,
            modal = _action$modal === undefined ? MODALS.DEFAULT : _action$modal,
            _action$props = action.props,
            props = _action$props === undefined ? {} : _action$props;


        return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, modal, (0, _extends6.default)({}, initialState[modal], props, { isOpen: true })));
      }

    case HIDE_MODAL:
      {
        var _action$modal2 = action.modal,
            _modal = _action$modal2 === undefined ? MODALS.DEFAULT : _action$modal2,
            _action$props2 = action.props,
            _props = _action$props2 === undefined ? {} : _action$props2;

        return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, _modal, (0, _extends6.default)({}, initialState[_modal], _props, { isOpen: false })));
      }

    case SET_MODAL_PROPS:
      {
        var _action$modal3 = action.modal,
            _modal2 = _action$modal3 === undefined ? MODALS.DEFAULT : _action$modal3,
            _action$props3 = action.props,
            _props2 = _action$props3 === undefined ? {} : _action$props3;

        return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, _modal2, (0, _extends6.default)({}, state[_modal2], _props2)));
      }

    default:
      return state;
  }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */

var show = exports.show = function show() {
  var modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODALS.DEFAULT;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return { type: SHOW_MODAL, modal: modal, props: props };
};

var hide = exports.hide = function hide() {
  var modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODALS.DEFAULT;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return { type: HIDE_MODAL, modal: modal, props: props };
};

var setProps = exports.setProps = function setProps() {
  var modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MODALS.DEFAULT;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: SET_MODAL_PROPS,
    modal: modal,
    props: props
  };
};

/* eslint-disable */

/* MODAL PROPS:
 *  See EnterpriseModal Component for more info
 * -------------------------------------------------------------------------------------------------
 * isOpen <boolean> flag which says if the modal is opened or not
 * isStatic <boolean> disable closing the modal from modal own methods
 * isBasic <boolean> type of the modal
 * autoWrap <boolean> wrap body for customization
 * transitionName <string> the name of the transition to be able to overwrite it
 * transitionDuration <number> duration of the transitions, can be overridden by transitionEnter or transitionLeave
 * transitionEnter <number> duration of the enter transition
 * transitionLeave <number> duration of the leave transition
 * children <node> body content / node or string /
 * header <node> header content / node or string /
 * footer <node> footer content / node or string /
 * body <node> body content, is equals to children, but children has priority over body / node or string /
 * onToggle <function> callback which fires when the modal change its visibility
 * onCancel <function> callback which fires when the modal is closed
 * onConfirm <function> callback which fires when the modal is opened
 * backdropClassName <string> Adds a class to backdrop component to be able to overwrite styles
 * dialogClassName <string> Adds a class to dialog component to be able to overwrite styles
 * headerClassName <string> Adds a class to header component to be able to overwrite styles
 * footerClassName <string> Adds a class to footer component to be able to overwrite styles
 * bodyClassName <string> Adds a class to body component to be able to overwrite styles
 */

/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/modals.js
// module id = 80
// module chunks = 0